export const TELECOM_ROUTES = {
  OVERVIEW: '/telecom/sim/overview/' as const,
};
